(function () {
var $197cd56b15c33885$exports = {};
"use strict";
var $197cd56b15c33885$var$swiper = new Swiper(".mySwiper", {
    pagination: {
        el: ".swiper-pagination",
        type: "fraction"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});

})();
//# sourceMappingURL=index.23271dd4.js.map
